// extracted by mini-css-extract-plugin
module.exports = {"extrasContainer":"BcjOo38SxIOjm6h1wfMKTQ=="};